import * as Yup from 'yup';

export const emailValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email('invalidEmailError')
    .max(255)
    .required('requiredEmail'),
});
